import { el } from './dom';

/**
 * Przejście między ekranami: obraz ściemnia się, na środku pojawia się nazwa miejsca,
 * a nowa scena wyłania się z ciemności. Zasłania też chwilę kompilowania shaderów.
 */
export class Transition {
  private readonly root = el('div', 'transition');
  private readonly title = el('div', 'transition-title');
  private readonly subtitle = el('div', 'transition-sub');

  constructor() {
    this.root.append(this.subtitle, this.title);
    document.getElementById('ui')!.append(this.root);
  }

  /** Ściemnia ekran (z napisem) i czeka, aż ściemnienie się skończy. */
  cover(title = '', subtitle = ''): Promise<void> {
    this.title.textContent = title;
    this.subtitle.textContent = subtitle;
    this.root.classList.add('on');
    this.root.classList.toggle('titled', !!title);
    return new Promise((res) => setTimeout(res, 380));
  }

  /** Odsłania nową scenę. */
  reveal(delay = 0): void {
    setTimeout(() => this.root.classList.remove('on'), delay);
  }
}
